<div class="w-100 mt-0 tool-container">
  <h4>Request Report Template</h4>
  <mat-form-field class="me-3">
    <mat-label>Template</mat-label>
    <mat-select [(ngModel)]="selectedRequestReportTemplate">
      @for (template of reportTemplates; track template) {
        <mat-option [value]="template">
          {{ template }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    [disabled]="!selectedRequestReportTemplate"
    (click)="requestReportTemplate()"
  >
    Request
  </button>
  @if (selectedRequestReportStatus) {
    <h4 class="col-12 {{ selectedRequestReportStatusClass }}">
      {{ selectedRequestReportStatus }}
    </h4>
  }
  <div>
    <pre>{{ selectedRequestReport }}</pre>
  </div>
</div>
